module.exports = __webpack_public_path__ + "img/img-e2e199.png";